export enum DEVIS_ROUTES {
  GET_ALL = "/devis",
  GET = "/devis/",
  CREATE = "/devis",
  UPDATE = "/devis/",
  REMOVE = "/devis/",
  DOWNLOAD = "/devis/",
  SEND = "/mail/send",
}
